module.exports = __webpack_public_path__ + "assets/img/Sonance_005.1b769e1c.jpg";